import { CartItem } from 'components/cartItem';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import './CartItemSide.css';

const CartItemSide = ({
    title,
    descriction,
    price,
    priceText,
    priceDescription,
    img,
    addOnText,
    hasCartExtras,
    extraClass,
}) => {
    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);
    const propName = useSelector(
        (state) => state.miniBookingWidget?.data?.multiPropertyParentName
    );
    const propertyLogo = useSelector(
        (state) => state.miniBookingWidget?.data?.propertyLogo
    );
    const items = useSelector((state) => state.cart?.cartItems);
    const currency = useSelector((state) => state.user?.currency);
    const finalPrices = useSelector((state) => state.cart?.finalPrices);
    const firstIncompleteIndex = items.findIndex((item) => !item.isCompleted);
    const currentStep = useSelector((state) => state.cart?.currentStep);
    return (
        <div className={`ab-cart-side-wrapper ${extraClass}`}>
            <div className="ab-cart-side-upper">
                <div className="ab-cart-side-img">
                    <img src={propertyLogo} />
                </div>
                <div className="ab-cart-side-general">
                    <div style={{ marginBottom: '5px' }}>
                        {Lang?.yourBooking}
                    </div>
                    <span>{Lang?.propertyDetails}</span>
                    <span className="ab-cart-side-property-name">
                        {propName}
                    </span>
                </div>
            </div>
            {items?.map((item, index) => {
                let selected = index === firstIncompleteIndex;
                if ((currentStep === 2 || currentStep === 3) && index === 0) {
                    selected = true;
                }
                return (
                    <CartItem
                        key={index}
                        item={item}
                        count={+index + 1}
                        selected={selected}
                        hasCartExtras={hasCartExtras}
                    />
                );
            })}
            {currentStep === 2 ||
                (currentStep === 3 && (
                    <div className="ab-sidebar_total">
                        <table>
                            <tbody>
                                <tr valign="top">
                                    <td style={{ width: '50%' }}>
                                        {Lang?.total}
                                    </td>
                                    <td
                                        className="ab-js-pricetag"
                                        style={{ width: '50%' }}
                                    >
                                        <p>
                                            {currency} &nbsp;
                                            {finalPrices?.totalPayment}
                                            <span>
                                                {finalPrices?.cartPolicy}
                                            </span>
                                        </p>
                                    </td>
                                </tr>

                                {/* {finalPrices?.totalPayment !==
                                    finalPrices?.paymentAmount && (
                                    <tr valign="top">
                                        <td style={{ width: '50%' }}>
                                            {Lang?.paymentAmount}
                                        </td>
                                        <td
                                            className="ab-js-pricetag"
                                            style={{ width: '50%' }}
                                        >
                                            <p>
                                                {currency} &nbsp;
                                                {finalPrices?.paymentAmount}
                                            </p>
                                        </td>
                                    </tr>
                                )} */}
                            </tbody>
                        </table>
                    </div>
                ))}
        </div>
    );
};

CartItemSide.propTypes = {
    title: PropTypes.string,
    descriction: PropTypes.string,
    price: PropTypes.string,
    priceText: PropTypes.string,
    priceDescription: PropTypes.string,
    img: PropTypes.string,
    addOnText: PropTypes.string,
    hasCartExtras: PropTypes.bool,
    extraClass: PropTypes.string,
};

export default CartItemSide;
